"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevEnvironment = void 0;
/** Check if running in dev environment (localhost, 127.0.0.1, URL contains -dev, or NODE_ENV=development) */
const isDevEnvironment = () => (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') ||
    (typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.href.toLowerCase().includes('-dev')));
exports.isDevEnvironment = isDevEnvironment;
